// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4c1fa99a","433":"43ee3b4c","453":"7e3afa34"}[chunkId] + ".chunk.js";
};